import React from 'react';
import MetricTile from '../MetricTile';
import { fmtCount, fmtRatioPct } from '../lib/format';

/**
 * Evidence for `discover_traffic` and `image_search` — the two non-web surfaces.
 *
 * `facts`: same shape as `search_headline.facts` minus `comparison`
 *          { impressions, clicks, ctr, avg_position, … }
 *
 * Position is deliberately never shown here:
 *  - Discover has no search terms at all, so `avg_position` is always `null`. The tile
 *    is omitted rather than rendered as a dash (F18).
 *  - Image search carries a position, but images rank deep by nature — a position of 38
 *    is normal there and alarming next to the web position of 11. Showing it invites a
 *    comparison across grains that means nothing (F8).
 */
const SurfaceStat = ({ facts }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
    <MetricTile label="Showed up in searches" value={fmtCount(facts?.impressions)} variant="muted" icon="target" />
    <MetricTile label="Visits" value={fmtCount(facts?.clicks)} variant="highlight" icon="click" />
    <MetricTile label="Click rate" value={fmtRatioPct(facts?.ctr)} variant="success" icon="percent" />
  </div>
);

export default SurfaceStat;
